import React from 'react';
import PropTypes from 'prop-types';

// VERY DEPRICATED !!!!!
// use src/core/gd-components/buttons/gd-button/gd-button-ui5-new.tsx

export default class ButtonDepricated extends React.Component<any,any> {

    static propTypes = {
        onClick: PropTypes.any,
        label: PropTypes.string,
        type: PropTypes.oneOf(['primary','normal','secondary','blue','gray','busy','disabled', 'on-white']),
        size: PropTypes.oneOf(['30','36']),
        icon: PropTypes.string,

        iconPosition: PropTypes.oneOf(['left','right']),

        disabled: PropTypes.bool
    };

    static defaultProps = {
        size: '30',
        iconPosition: 'left',
        disabled: false
    };

    state = {
        type: this.props.type
    };

    componentDidUpdate(prevProps:any, prevState:any) {
        if(prevState.type !== this.props.type) {
            this.setState({
                type: this.props.type
            });
        }
    }

    setType(value:any) {
        if (['primary','normal','secondary','busy','disabled'].includes(value)) {
            this.setState({
                type: value
            });
        }
    }

    onClick = (e:React.SyntheticEvent) => {
        if (this.state.type === 'busy' || this.state.type === 'disabled' || this.props.disabled) e.preventDefault();
        else if (this.props.onClick) this.props.onClick(e);
    }

    render() {
        const { size } = this.props;
        const { type } = this.state;

        const classes = Classes('ui5-button', this.props.className, {
            's30':          size === "30",
            's36':          size === '36',
            'primary':      type === 'primary',
            'secondary':    type === 'secondary',
            'busy':         type === 'busy',
            'disabled':     type === 'disabled' || this.props.disabled,
            'on-white':     type === 'on-white',
            'on-gray':      type === 'on-gray',
            'with-icon':    !!this.props.icon,
        });
        let buttonIcon = null;
        let buttonLabel = this.props.label;

        if (this.props.icon) {
            buttonIcon = <span key="icon" className={Classes("icon", this.props.icon)}/>
            buttonLabel = <span key="txt" className="txt">{this.props.label}</span>
        }

        if (type === 'busy') {
            buttonLabel = null;
            const btnSrc = gdConfig.assetsPath+"/skin/common/loader/btn-submit-busy.gif";
            buttonIcon = <img key="image" src={btnSrc} />
        }

        let content;
        switch(this.props.iconPosition) {
            case 'left': content = [buttonIcon, buttonLabel]; break;
            case 'right': content = [buttonLabel, buttonIcon]; break;
        }

        return (
            <div className={classes} onClick={this.onClick} style={this.props.style}>
                {content}
            </div>
        );
    }
};
